import React from "react";
import Title from "../../ui/Title";

const SchemesAndPolicies = () => {
  return (
    <div>
      <Title title="Schemes and policies to strengthen the care economy" />

      <div className="space-y-4 text-softBlack leading-loose text-base font-normal mt-4">
        <p>
          Countries are increasingly realizing the importance of addressing the
          gaps in their own care economies, and are formulating, implementing
          and evaluating schemes which can support caregivers through financial
          or in-kind assistance (such as nutrition support), and enable them to
          stay in the workforce despite their care load. Several schemes and
          policies have been implemented to benefit caregivers and their
          dependents. These include:
        </p>
        <ul className="list-disc list-outside space-y-2 ml-6">
          <li>Training of caregivers</li>
          <li>Palliative care</li>
          <li>
            Financial support to caregivers and patients (for e.g., Direct
            benefit transfers, compensation schemes)
          </li>
          <li>
            Leave for caregivers, including parental leave and childcare leave
          </li>
          <li>
            Incentives to NGOs/corporations to support/provide caregiving
            services
          </li>
          <li>Mental health support</li>
        </ul>

        <p>
          There are also schemes and policies which have been formulated keeping
          in mind larger vulnerable groups, such as the socio-economically
          disadvantaged. Some or all provisions of these schemes or policies
          have benefits for the caregiver and patient.
        </p>

        <p>
          Schemes and policies that indirectly benefit the needs of the
          caregivers and their dependents, include:
        </p>
        <ul className="list-disc list-outside space-y-2 ml-6">
          <li>Health insurance</li>
          <li>Digital healthcare technology</li>
          <li>Nutrition support</li>
          <li>
            Social security schemes such as pensions, financial assistance due
            to socio-economic vulnerabilities such as poverty
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SchemesAndPolicies;
